<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="pageTitle"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
    </div>


    <div v-if="this.active != 1" class="mb-2">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-if="this.active < 4"> <a href="" @click.prevent="previous">List</a></el-breadcrumb-item>
        <el-breadcrumb-item>Profile</el-breadcrumb-item>
        <!-- <el-breadcrumb-item v-if="statusCheck" ><h5 :class="statusCheck == '1' ? 'text-success' : 'text-warning'">{{statusCheck == '1' ? 'Approved' : 'Pending'}}</h5></el-breadcrumb-item> -->

      </el-breadcrumb>
    </div>
   

    <el-form v-if="active === 1">
      <app-table :options="options" :id="tableId" @action="getListAction" />
    </el-form>

    <el-form v-if="active === 2">
      <my-profile :id="userId" :statusCheck="statusCheck" :remove="classRemove"></my-profile>
    </el-form>

    <el-form v-if="active === 3">
      <allsupplier-chat :name="userName" :userType="userType" :remove="classRemove"></allsupplier-chat>
    </el-form>

    <supplier-taskmodal
      v-if="isFormModalActive"
      :id="userId"
      :name="userName"
      :table-id="tableId"
      :role="'Buyer'"
      @close-modal="closeFormModal"
    />
    <!-- ShortList Approved -->
    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="supplier-shortlist-approve"
      :message="message"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
  </div>
</template>
<script>
import CoreLibrary from "../../../../../../core/helpers/CoreLibrary";
import * as actions from "../../../../../Config/ApiUrl";
import { TableHelpers } from "../../../Demo/Tables/mixins/TableHelpers";
import AppFunction from "../../../../../../core/helpers/app/AppFunction";

export default {
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  mixins: [TableHelpers],
  data() {
    return {
      statusCheck: '',
      message: '',
      pageTitle: '',
      classRemove: true,
      userName: '',
      userType: '',
      active: 1,
      userId: 0,
      userName: "",
      isFormModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      tableId: "table-shortlist",
      rowData: {},
      options: {
        name: "TableShortlist",
        url: actions.SHORTLISTED_SUPPLIERS,
        showHeader: true,
        columns: [
          {
            title: this.$t("company_name"),
            type: "custom-html",
            key: "company",
            modifier: (value, row) => {
              return `<a href="#" id="${row.id}" @click=${this.myFunction(row)}>${this.$t(value.company_name)}</a>`;
            },
          },
          {
            title: this.$t("start_date"),
            type: "custom-html",
            key: "company",
            modifier: (value) => {
              return `<span>${this.$t((value.start_date)?value.start_date:'---')}</span>`;
            },
          },
          {
            title: this.$t("end_date"),
            type: "custom-html",
            key: "company",
            modifier: (value) => {
              return `<span>${this.$t((value.end_date)?value.end_date:'---')}</span>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "pivot",
            isVisible: true,
            modifier: (value) => {
              let ClassName = "danger";
              let status = 'Pending';
              if (value.status === 1){
                    ClassName = `success`;
                    status = 'Approved';
              } 
              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(status)}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("assign_form"),
            icon: "edit",
            type: "none",
          },
          {
            title: this.$t("view_profile"),
            icon: "eye",
            type: "none",
          },
          {
            title: this.$t("approved"),
            icon: "thumbs-up",
            type: "none",
          },
          {
            title: this.$t("chat"),
            icon: "message-circle",
            type: "none",
          },
        ],
        filters: [
          // {
          //   title: this.$t("date"),
          //   type: "range-picker",
          //   key: "date",
          //   option: ["today", "thisMonth", "last7Days", "nextYear"],
          // },
          // {
          //   title: this.$t("age"),
          //   type: "range-filter",
          //   key: "age-range",
          //   maxTitle: this.$t("max_age"),
          //   minTitle: this.$t("min_age"),
          //   sign: "",
          // },
          {
            title: this.$t("status"),
            type: "radio",
            key: "status",
            option: [
              { id: "1", value: "Approved" },
              { id: "0", value: "Pending" },
            ],
            header: {
              title: this.$t("want_to_filter_supplier_by_status"),
              description: this.$t(
                "select_status"
              ),
            },
          },
          // {
          //   title: this.$t("gender"),
          //   type: "radio",
          //   key: "filter-with-gender",
          //   option: [
          //     { id: "male", value: "Male" },
          //     { id: "female", value: "Female" },
          //     { id: "other", value: "Other" },
          //   ],
          //   header: {
          //     title: this.$t("want_to_filter_your_list"),
          //     description: this.$t(
          //       "you_can_filter_your_data_table_which_are_created_based_on_gender"
          //     ),
          //   },
          // },
          // {
          //   title: this.$t("search_and_select"),
          //   type: "drop-down-filter",
          //   key: "search select",
          //   option: [],
          // },
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        // showAction: true,
        orderBy: "desc",
        // actionType: "default",
      },
    };
  },
  created() {
    this.pageTitle = this.$t('shortlisted_buyers');
    this.options.columns = [...this.options.columns, this.actionObj];
    this.options.url = actions.SHORTLISTED_SUPPLIERS+'?role=Buyer';
    // this.searchAndSelectFilterOptions();
  },
  methods: {
    /**
     * for open add edit modal
     */
    previous() {
      this.pageTitle = this.$t('shortlisted_buyers');
      this.active = 1;
    },
    openFormModal() {
      this.isFormModalActive = true;
    },
    closeFormModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isFormModalActive = false;
      // this.searchAndSelectFilterOptions();
    },

    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == this.$t("assign_form")) {
        // this.selectedUrl = `${actions.DATATABLE_DATA}/${rowData.id}`;
        this.userId = rowData.id;
        this.userName = rowData.full_name;
        this.openFormModal();
      } else if (actionObj.title == this.$t("view_profile")) {
        this.pageTitle = 'Buyer Profile';
        // this.userId = rowData.id;
        // this.statusCheck = rowData.pivot.status;
        // this.active = 2;
         this.view(rowData);
      } else if (actionObj.title == this.$t("approved")) {
        this.pageTitle = 'Buyer Profile';
        this.shortlist();
      } else if (actionObj.title == this.$t("chat")) {
        this.userName = rowData.full_name;
        this.pageTitle = 'Chat with ' + this.userName;
        this.userType = 'shortlisted_buyers';
        this.active = 3;
        //  this.view(rowData);
      }
    },
       view(rowData) {
            this.pageTitle = 'Buyer Profile';
            this.userId = rowData.id;
            this.statusCheck = rowData.pivot.status;
            this.active = 2;
        },
        myFunction(data){
            let doc = document.getElementById(data.id);
            if(doc){
                doc.addEventListener('click', () => {
                this.view(data);
            }); 
          }
        },
    /**
     * for open confirmation modal
     */
    shortlist() {
      this.message = 'You want to approved this buyer!';
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.SHORTLIST_SUPPLIER_APPROVED}/${this.rowData.pivot.id}?role=Buyer`;
      this.deleteLoader = true;
      this.axiosGet(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#supplier-shortlist-approve").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
          this.$hub.$emit("reload-" + this.tableId);
        })
        .catch(({ error }) => {
          // Trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.$hub.$emit("reload-" + this.tableId);
      this.rowData = {};
      this.selectedUrl = "";
    },
    // searchAndSelectFilterOptions() {
    //   this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then((response) => {
    //     let name = this.options.filters.find(
    //       (element) => element.title === this.$t("search_and_select")
    //     );

    //     name.option = response.data.map((name) => {
    //       return {
    //         id: name.name,
    //         value: name.name,
    //       };
    //     });
    //   });
    // },
  },
};
</script>
